import React, { useContext, useState } from 'react';
import { useRouter } from 'next/router';
import { appAuthContext } from 'context/AuthContext';
import getUser from 'api/requests/getUser';
import showNotification from 'utils/showNotification';
import Modal from '../Modal';
import LogoutRequest from './api/LogoutRequest';
import { LogoutModalProps } from './LogoutModal.props';
import styles from './LogoutModal.module.css';

const LogoutModal = ({ onClose }: LogoutModalProps) => {
  const { setUser } = useContext(appAuthContext);
  const [pending, setPending] = useState(false);
  const router = useRouter();

  const logoutHandler = async () => {
    setPending(true);
    const res = await LogoutRequest();
    if (res?.data?.userLogOut?.payload?.success === true) {
      const updateUserData = await getUser();
      setUser(updateUserData);
      await router.push(`/`);
    } else {
      showNotification('error', 'Возникла ошибка');
    }
    setPending(false);
    onClose();
  };

  return (
    <Modal onClose={onClose} useCloseBtn={false} allowCloseOnClickOutside={true}>
      <div className={styles.logout}>
        <div className={styles.logout__icon} />
        <span className={styles.logout__text}>
          При выходе из&nbsp;Учи.Ответов ты&nbsp;также выйдешь из&nbsp;остальных сервисов
          Учи.ру
        </span>
        <div className={styles.btns}>
          <button
            disabled={pending}
            onClick={logoutHandler}
            className={`${styles.btn} ${styles.btns__logout}`}
            data-qa-marker="logout_accept_btn "
          >
            Выйти
          </button>
          <button className={`${styles.btn} ${styles.btns__stay}`} onClick={onClose}>
            Остаться
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default LogoutModal;
